import Icon from '@mdi/react'
import { PagesEnum } from '../../utils/Enums'
import { Tabs, Layout } from 'antd'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

const TabsPanel = (props) => {
	const { collection } = props
	const { tabStatus } = useParams()
	const { pathname } = useLocation()
	const navigate = useNavigate()

	return (
		<Layout.Header className={'sticky items-center !p-0 !h-[50px]'}>
			<Tabs
				activeKey={tabStatus}
				className='w-full'
				onChange={(key) => {
					navigate(`${pathname?.replace(`/${tabStatus}`, '')}/${key}`)
				}}
				items={Object.values(PagesEnum[collection]?.tabsEnum).map((status) => ({
					key: status.key,
					label: (
						<div className='flex flex-row px-4 items-center'>
							<Icon className='mr-2' size={0.8} path={status.icon} /> {status.text}
						</div>
					),
				}))}
			/>
		</Layout.Header>
	)
}

export default TabsPanel
